import React, { useState, useEffect } from "react";
import { bool } from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import Action from "pages/_components/Action";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Notification from "pages/_components/Notification";
import { debinTitles, debinTabTitles } from "util/debin";
import { actions as debinActions } from "reducers/debin";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { push } from "connected-react-router";
import * as i18n from "util/i18n";
import { isIOS } from "react-device-detect";
import EmitedDebin from "./EmitedDebin";
import ReceivedDebin from "./ReceivedDebin";
import RecurentDebin from "./RecurentDebin";

const IncomingDebinList = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { state = { tab: 0 } } = useLocation();
    const [tabIndex, setTabIndex] = useState(state.tab);
    const debinMainTitle = debinTitles[tabIndex];
    useEffect(() => {
        dispatch(debinActions.setBeneficiary({}));
        dispatch(debinActions.setdebinPrestacionData({}));
        dispatch(debinActions.setSolicitDebin({}));
    }, []);

    const tabsData = [
        {
            text: debinTabTitles[0],
            textType: "I18N",
        },
        {
            text: debinTabTitles[1],
            textType: "I18N",
        },
        {
            text: debinTabTitles[2],
            textType: "I18N",
        },
    ];

    return (
        <>
            <Notification scopeToShow="debinPayments" />
            <ResponsiveHeader id={debinMainTitle || "debin.main.title"} backLinkTo="/desktop">
                <DesktopButtons buttonExtra>
                    <Link className="btn btn-primary btn-block" to="/debinPayments/solicitDebin">
                        <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                        <I18n id="debin.solicit" />
                    </Link>
                    <CustomButton
                        className="toolbar-item toolbar-item-head"
                        icon="images/figma/icon/menu-mobile.svg"
                        pullRight
                        options={[
                            {
                                text: i18n.get("debin.AddRecurence"),
                                func: () => dispatch(push("/debinPayments/AddRecurence")),
                            },
                            {
                                text: i18n.get("debin.AddAccount"),
                                func: () => dispatch(push("/debinPayments/addAccount")),
                            },
                        ]}
                    />
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="debin.solicit" to="/debinPayments/solicitDebin" />
                    <Action labelKey="debin.AddAccount" to="/debinPayments/addAccount" />
                    <Action labelKey="debin.AddRecurence" to="/debinPayments/AddRecurence" />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer className="debin">
                <CustomTabs tabsData={tabsData} setCurrentTab={setTabIndex}>
                    <ReceivedDebin isDesktop={isDesktop} />
                    <EmitedDebin isDesktop={isDesktop} />
                    <RecurentDebin isDesktop={isDesktop} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};
IncomingDebinList.defaultProps = {};

IncomingDebinList.propTypes = {
    isDesktop: bool.isRequired,
};

export default IncomingDebinList;
